module.exports = __webpack_public_path__ + "static/media/MrMsSmith.9ccbb129.jpg";